/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_Editor_ListInputs */



/**
* | output |
* | --- |
* | "Editor List" |
*
* @param {Options_Editor_Section_Editor_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_editor_list = /** @type {((inputs?: Options_Editor_Section_Editor_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_Editor_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste de l'éditeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Redakteursliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco degli editori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список редакторов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de editores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集者リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादक सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de editores")
	return /** @type {LocalizedString} */ ("Editor List")
});